import styled from '@emotion/styled';
import Link from 'next/link';
import { Section } from '@/components/pages/about/comm/Layout';
import { buttonStyle } from '@/components/pages/about/styles/button';
import {
  headline03,
  title02,
} from '@/components/pages/about/styles/typography';
import { breakpointMedium } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';

const OutroSection = () => {
  return (
    <StyledSectionContainer>
      <StyledSectionInner>
        <Title>
          응시 직후 바로 결과 확인하고, 취업 활동에 빠르게 활용하세요!
        </Title>

        <Link href="/tryouts">
          <CtaButton>
            <CtaButtonText>시험 일정 확인하고 접수하기</CtaButtonText>
          </CtaButton>
        </Link>
      </StyledSectionInner>
    </StyledSectionContainer>
  );
};

export default OutroSection;

const StyledSectionContainer = styled(Section.Container)`
  background-color: #132041;
`;

const StyledSectionInner = styled(Section.Inner)`
display: flex;
flex-direction: column;
align-items: center;
padding: 80px 16px;
gap: 32px;

@media (max-width: ${breakpointMedium}) {
  padding: 80px 20px;
}
`;

const Title = styled.h2`
${headline03}
color: ${colors.white};
text-align: center;
`;

const CtaButton = styled.button`
${buttonStyle.primary}
width: 300px;
padding: 17px;
`;

const CtaButtonText = styled.span`
${title02}

display: flex;
align-items: center;
justify-content: center;
gap: 8px;
`;
